var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.20101 2 1.5 6.70101 1.5 12.5C1.5 18.299 6.20101 23 12 23C17.799 23 22.5 18.299 22.5 12.5C22.5 6.70101 17.799 2 12 2ZM3.75 12.5C3.75 7.94365 7.44365 4.25 12 4.25C13.8725 4.25 15.5994 4.87385 16.984 5.92505L5.42505 17.484C4.37385 16.0994 3.75 14.3725 3.75 12.5ZM7.01603 19.075C8.40065 20.1262 10.1275 20.75 12 20.75C16.5563 20.75 20.25 17.0563 20.25 12.5C20.25 10.6275 19.6262 8.90065 18.575 7.51603L7.01603 19.075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.dd892ca951bdd2deb7e3b048f79f28c7.svg";
export { ForwardRef as ReactComponent };